import { createAsyncActions } from "~/utils/store";

export const LOAD_BANK_STATEMENTS = createAsyncActions("@@BANK_RECONCILIATION/LOAD");
export const IMPORT_BANK_STATEMENTS = createAsyncActions("@@BANK_RECONCILIATION/IMPORT");
export const CREATE_RECONCILIATION = createAsyncActions("@@BANK_RECONCILIATION/RECONCILE");
export const REMOVE_RECONCILIATION = createAsyncActions("@@BANK_RECONCILIATION/UNRECONCILE");
export const GET_SUGGESTIONS = createAsyncActions("@@BANK_RECONCILIATION/SUGGESTIONS");
export const BULK_DELETE = createAsyncActions("@@BANK_RECONCILIATION/BULK_DELETE");
export const IGNORE_STATEMENTS = createAsyncActions("@@BANK_RECONCILIATION/IGNORE");
export const UNIGNORE_STATEMENTS = createAsyncActions("@@BANK_RECONCILIATION/UNIGNORE");
export const AUTO_RECONCILE = createAsyncActions("@@BANK_RECONCILIATION/AUTO_RECONCILE");
export const GET_STATS = createAsyncActions("@@BANK_RECONCILIATION/GET_STATS");
export const SET_DRAWER = "@@BANK_RECONCILIATION/SET_DRAWER";
export const SET_PENDING_MATCH = "@@BANK_RECONCILIATION/SET_PENDING_MATCH";

export var loadBankStatements = function(params) {
    var from = params.from;
    var to = params.to;
    var status = params.status;
    var view = params.view || 'period';
    var bankAccountId = params.bank_account_id;

    var url = "/bank-reconciliation/statements?status=" + status;

    // Only add date filter for period view
    if (view === 'period' && from && to) {
        url += "&from=" + from + "&to=" + to;
    }

    if (bankAccountId) {
        url += "&bank_account_id=" + bankAccountId;
    }

    return {
        type: LOAD_BANK_STATEMENTS.INIT,
        payload: {
            request: {
                method: "get",
                url: url,
            },
            filter: {
                from: from,
                to: to,
                status: status,
                view: view,
                selectedBankId: bankAccountId || null,
            },
        },
    };
};

export var importBankStatements = function(data) {
    return {
        type: IMPORT_BANK_STATEMENTS.INIT,
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/import",
                data: data,
            },
        },
    };
};

export var createReconciliation = function(data) {
    return {
        type: CREATE_RECONCILIATION.INIT,
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/reconcile",
                data: data,
            },
        },
        statementId: data.bank_statement_id,
    };
};

export var removeReconciliation = function(id, statementId) {
    return {
        type: REMOVE_RECONCILIATION.INIT,
        payload: {
            request: {
                method: "delete",
                url: "/bank-reconciliation/reconcile/" + id,
            },
        },
        id: id,
        statementId: statementId,
    };
};

// `todoHistorico` manda periodo=tudo, que faz o backend buscar sem janela de
// data. É para o caso do cliente que acumula meses e paga tudo de uma vez: a
// cobrança pode ter vencido anos antes do recebimento cair.
// `busca` vai para o servidor (nome/código do cliente ou código ME/SOC do
// título) e procura no histórico inteiro, não só no que já veio para a tela.
export var getSuggestions = function(statementId, recordTypes, from, to, todoHistorico, busca) {
    var types = Array.isArray(recordTypes) ? recordTypes.join(',') : recordTypes;
    var url = "/bank-reconciliation/suggestions/" + statementId + "?types=" + types;
    if (busca) {
        url += "&busca=" + encodeURIComponent(busca);
    } else if (todoHistorico) {
        url += "&periodo=tudo";
    } else if (from && to) {
        url += "&from=" + from + "&to=" + to;
    }
    return {
        type: GET_SUGGESTIONS.INIT,
        payload: {
            request: {
                method: "get",
                url: url,
            },
        },
        statementId: statementId,
    };
};

export var setDrawer = function(drawerState) {
    return {
        type: SET_DRAWER,
        payload: drawerState,
    };
};

export var bulkDelete = function(ids) {
    return {
        type: BULK_DELETE.INIT,
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/bulk-delete",
                data: { ids: ids },
            },
        },
        ids: ids,
    };
};

export var autoReconcile = function(types, statementIds) {
    var data = { types: types || ['mensalidades', 'extras', 'comissoes'] };
    // Only reconcile the statements the user kept (non-excluded) in the
    // AutoReconcileDrawer. When omitted, the backend reconciles all pending.
    if (Array.isArray(statementIds)) {
        data.statement_ids = statementIds;
    }
    return {
        type: AUTO_RECONCILE.INIT,
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/auto-reconcile",
                data: data,
            },
        },
    };
};

export var getStats = function(bankAccountId) {
    var url = "/bank-reconciliation/stats";
    if (bankAccountId) {
        url += "?bank_account_id=" + bankAccountId;
    }
    return {
        type: GET_STATS.INIT,
        payload: {
            request: {
                method: "get",
                url: url,
            },
        },
    };
};

export var checkDuplicates = function(statements) {
    return {
        type: "@@BANK_RECONCILIATION/CHECK_DUPLICATES",
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/check-duplicates",
                data: { statements: statements },
            },
        },
    };
};

export var CREATE_AND_RECONCILE = createAsyncActions("@@BANK_RECONCILIATION/CREATE_AND_RECONCILE");

export var createAndReconcile = function(data) {
    return {
        type: CREATE_AND_RECONCILE.INIT,
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/create-and-reconcile",
                data: data,
            },
        },
        statementId: data.bank_statement_id,
    };
};

export var LOAD_IMPORTS = createAsyncActions("@@BANK_RECONCILIATION/LOAD_IMPORTS");
export var DELETE_IMPORT = createAsyncActions("@@BANK_RECONCILIATION/DELETE_IMPORT");

export var loadImports = function() {
    return {
        type: LOAD_IMPORTS.INIT,
        payload: {
            request: {
                method: "get",
                url: "/bank-reconciliation/imports",
            },
        },
    };
};

export var deleteImport = function(id) {
    return {
        type: DELETE_IMPORT.INIT,
        payload: {
            request: {
                method: "delete",
                url: "/bank-reconciliation/imports/" + id,
            },
        },
        importId: id,
    };
};

export var setPendingMatch = function(statementId, selectedItem) {
    return {
        type: SET_PENDING_MATCH,
        payload: { statementId: statementId, selectedItem: selectedItem },
    };
};

export var ignoreStatements = function(ids, reason) {
    return {
        type: IGNORE_STATEMENTS.INIT,
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/ignore",
                data: { ids: ids, reason: reason || '' },
            },
        },
        ids: ids,
    };
};

export var unignoreStatements = function(ids) {
    return {
        type: UNIGNORE_STATEMENTS.INIT,
        payload: {
            request: {
                method: "post",
                url: "/bank-reconciliation/unignore",
                data: { ids: ids },
            },
        },
        ids: ids,
    };
};
